<template>
  <div id="app">
    <a-spin style="height:100%" :spinning="$store.state.loadding" tip="加载中...">
       <router-view/>
    </a-spin>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app{
  width: 100%;
  height: 100%;
}
.ant-spin-container{
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue